import React from 'react';

const Resume = () => {
	return (
		<div className='container'>
			<h1 className='animate__animated animate__fadeInUp'>Resume</h1>
		</div>
	);
};

export default Resume;
